import gql from "../gql";
import Progress from "./Progress";
import NextMilestone from "./NextMilestone";
export default gql `
  fragment Learning on LearningSummary {
    id
    type
    name
    nextMilestone {
      ...NextMilestone
    }
    label
    creatorName
    favorite
    description
    url
    audience
    color
    iconUrl
    pointTotal
    minuteTotal
    progress {
      ...Progress
    }
  }
  ${Progress}
  ${NextMilestone}
`;
